import React from 'react';
interface EmptyStateProps {
  emoji: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  emoji,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-8 px-4 text-center" data-id="element-992">
      <div className="text-4xl mb-3" data-id="element-993">{emoji}</div>
      <h3 className="font-sharp-grotesk text-lg font-medium mb-2" data-id="element-994">{title}</h3>
      {description && <p className="text-gray-600 text-sm mb-4 max-w-md" data-id="element-995">{description}</p>}
      {actionLabel && onAction && <button onClick={onAction} className="text-sm font-medium text-white bg-black px-4 py-1.5 rounded-lg hover:bg-gray-800 transition-colors" data-id="element-996">
          {actionLabel}
        </button>}
    </div>;
}